 <div *ngIf="errorService.errorMessage" class="alert alert-danger">
        <i class="fa-duotone fa-ban fa-lg" aria-hidden="true"></i>
        &nbsp;<span [innerHTML]="errorService.errorMessage"></span>
    </div>
